<template>
  <div class="creative-group-wrap">
    <div class="card-header">
      创意组<span class="num-text">{{ dataList.length }}/30</span>
      <span class="nodata-tip" v-if="showNoDataTip">请完善创意组数据</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" :disabled="!adCount" @click="newCreative">新增</el-button
        ><span class="center-line"></span>

        <el-dropdown @command="(key) => showMaterialModal(true, key)">
          <el-button icon="el-icon-plus" type="text">批量新增</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="video" :disabled="!adCount || isUnionSplash">批量添加视频素材</el-dropdown-item>
            <el-dropdown-item command="image" :disabled="!adCount">批量添加图片素材</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span class="center-line"></span>
        <el-button icon="el-icon-plus" type="text" :disabled="!adCount" @click="selectGroup">选择已有</el-button>

        <span class="center-line"></span>
        <el-button @click="clearAllGroup" type="text" :disabled="!adCount">清空</el-button>
      </div>
    </div>
    <div v-show="adCount && dataList.length > 0">
      <div class="card-list">
        <card-item
          v-for="(item, index) of dataList"
          :key="item.itemId"
          :title="'新建创意组' + (index + 1)"
          :dataSet="item"
          @edit="editCreativeGroup"
          @copy="copyCreativeGroup"
          @del="delCreativeGroup"
          :isCur="curItem.itemId === item.itemId"
          :showDelete="true"
        ></card-item>
      </div>
      <div class="modal-body" v-loading="loading">
        <ul class="modal-form">
          <el-form ref="modelRef" :model="formData" :rules="rules">
            <li class="form-item" style="margin-bottom: 0px">
              <span class="form-label" style="padding-top: 10px">创意组名称：</span>
              <div class="form-value">
                <el-form-item prop="creativeGroupName">
                  <el-input
                    v-model="formData.creativeGroupName"
                    placeholder="请填写"
                    style="width: 225px"
                    @input="changeGroupName"
                  ></el-input>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 4px">投放场景：</span>
              <div class="form-value">
                <div class="upload-header">
                  <el-form-item prop="curMaterialType">
                    <el-radio-group v-model="formData.curMaterialType">
                      <el-radio label="video" :disabled="isUnionSplash">视频({{ videoList.length }}/10)</el-radio>
                      <el-radio label="image">图片({{ imageList.length }}/12)</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-button
                    class="add-btn"
                    type="text"
                    icon="el-icon-plus"
                    @click="showMaterialModal(false)"
                    :disabled="
                      (formData.curMaterialType === 'video' && videoList.length >= 10) ||
                      (formData.curMaterialType === 'image' && imageList.length >= 12)
                    "
                    >添加素材</el-button
                  >
                </div>
                <div class="upload-wrap">
                  <div class="content-wrap video-wrap" v-show="formData.curMaterialType === 'video'">
                    <div class="video-item" v-for="item of videoList" :key="item.uuid">
                      <div class="video-slide">
                        <div class="video-header">视频:</div>
                        <div class="video-content">
                          <video controls="controls" class="material" :src="item.path"></video>
                        </div>
                      </div>
                      <div class="video-slide">
                        <div class="video-header">封面:</div>
                        <div class="video-content">
                          <img class="material" :src="item.coverPath" />
                        </div>
                      </div>
                      <span class="close-btn" @click="deleteItem(item.uuid)"><i class="el-icon-close"></i></span>
                    </div>
                  </div>
                  <div class="content-wrap image-wrap" v-show="formData.curMaterialType === 'image'">
                    <div class="img-item" v-for="item of imageList" :key="item.uuid">
                      <img class="img" :src="item.path" />
                      <span class="close-btn" @click="deleteItem(item.uuid)"><i class="el-icon-close"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </el-form>
        </ul>
        <span slot="footer" class="footer-wrap">
          <el-button @click="saveCreativeGroup" type="primary">保存到创意组</el-button>
          <!-- <el-button type="primary" @click="confirmSelect">确 定</el-button> -->
        </span>
      </div>
    </div>
    <div v-show="!adCount || dataList.length === 0" class="select-count">
      {{ dataList.length === 0 ? "暂无数据" : "请选择账户" }}
    </div>

    <!-- 素材选择弹框 -->
    <material-modal
      ref="materialModalRef"
      @selectOk="selectedMaterial"
      :selectType="formData.curMaterialType"
      :showGroupNum="showGroupNum"
      :isUnionSplash="isUnionSplash"
    ></material-modal>

    <!-- 选择已有创意组 -->
    <checked-modal
      title="选择创意组"
      :tableConf="tableConf"
      :tableData="tableData"
      ref="checkedModalRef"
      @selectOk="selectOk"
    ></checked-modal>
  </div>
</template>

<script>
import MaterialModal from "./subBaseset/sub/materialModal.vue";
import CheckedModal from "./common/checkedModal.vue";
import { getToutiaoId, saveCreativeGroup, queryCreativeGroup } from "@/api/promotion.js";
import { mapState } from "vuex";
import CardItem from "./common/cardItem.vue";
export default {
  components: {
    MaterialModal,
    CardItem,
    CheckedModal,
  },
  data() {
    return {
      tableConf: [
        { title: "创意组名称", colName: "group_name" },
        { title: "创建时间", colName: "createTimeStr" },
      ],
      tableData: [],
      dataList: [],
      curItem: {}, //当前编辑对象
      formData: {
        creativeGroupName: "",
        curMaterialType: "video",
      },
      videoList: [],
      imageList: [],
      loading: false,
      rules: {
        creativeGroupName: [{ required: true, message: "创意组名称必填", trigger: "blur" }],
        curMaterialType: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.videoList.length + this.imageList.length === 0) {
                callback(new Error("请上传视频或图片素材"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      showGroupNum: false, //是否批量添加创意组
      showNoDataTip: false,
      //穿山甲开屏时查询素材新增字段 imageType=SPLASH
      isUnionSplash: false,
    };
  },
  mounted() {
    this.newCreative();
  },
  methods: {
    newCreative() {
      if (this.dataList.length >= 30) {
        return;
      }
      this.curItem.group_name = this.formData.creativeGroupName;
      let newItem = {
        itemId: Math.random(),
        group_name: "新建创意组" + (this.dataList.length + 1),
        creatives: [],
      };
      this.dataList.push(newItem);
      // this.showEditModal(newItem);
      this.saveInstore();
    },
    editCreativeGroup(dataItem) {
      this.curItem.group_name = this.formData.creativeGroupName; //切换时保存当前的
      this.showEditModal(dataItem);
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    copyCreativeGroup(dataItem) {
      if (this.dataList.length >= 30) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(dataItem));
      this.dataList.push({
        itemId: Math.random(),
        group_name: copyData.group_name + "_复制",
        creatives: copyData.creatives,
      });
      this.saveInstore();
    },
    delCreativeGroup(dataItem) {
      let delIndex = this.dataList.findIndex((item) => item.itemId === dataItem.itemId);
      this.dataList.splice(delIndex, 1);
      this.saveInstore();
    },
    clearAllGroup() {
      this.dataList = [];
      this.saveInstore();
    },
    /**
     * flag: 素材组件内部是否展示分组信息
     * type: 素材组件展示的素材类型
     */
    showMaterialModal(flag, type) {
      this.showGroupNum = flag;
      type && (this.formData.curMaterialType = type);
      this.$nextTick(() => {
        this.$refs.materialModalRef.showModal();
      });
    },
    selectedMaterial(resData) {
      let { mapList, groupNum } = resData;
      if (groupNum) {
        this.fillAndSaveGroupData(mapList, groupNum);
      } else {
        this.fillAndSaveCurData(mapList);
      }
    },
    //分组保存数据
    fillAndSaveGroupData: async function (mapList, groupNum) {
      let videoList = [];
      let imageList = [];
      if (this.formData.curMaterialType === "video") {
        for (let dataItem of Object.values(mapList)) {
          videoList.push({
            uuid: dataItem.uuid,
            path: dataItem.path,
            coverPath: dataItem.coverPath,
          });
        }
      } else {
        for (let dataItem of Object.values(mapList)) {
          imageList.push({
            uuid: dataItem.uuid,
            path: dataItem.path,
          });
        }
      }

      let toutioaList = await this.formatData(videoList.concat(imageList));
      this.setGroupData(toutioaList.creatives, Number(groupNum));
    },
    //赋值组数据
    setGroupData(allList, groupNum) {
      //数据分组
      let creativeGroup = [];
      if (allList[0].image_ids) {
        //图片素材
        let subIdList = [];
        let subUrlList = [];
        let subUUIDList = [];
        allList[0].image_ids.forEach((item, index) => {
          subIdList.push(allList[0].image_ids[index]);
          subUrlList.push(allList[0].image_urls[index]);
          subUUIDList.push(allList[0].image_uuids[index]);
          if ((index + 1) % groupNum === 0) {
            creativeGroup.push([
              {
                image_ids: subIdList,
                image_urls: subUrlList,
                image_uuids: subUUIDList,
              },
            ]);
            subIdList = [];
            subUrlList = [];
            subUUIDList = [];
          }
        });
        if (subIdList.length > 0) {
          creativeGroup.push([
            {
              image_ids: subIdList,
              image_urls: subUrlList,
              image_uuids: subUUIDList,
            },
          ]);
        }
      } else {
        //视频素材
        let subList = [];
        allList.forEach((item, index) => {
          subList.push(item);
          if ((index + 1) % groupNum === 0) {
            creativeGroup.push(subList);
            subList = [];
          }
        });
        if (subList.length > 0) {
          creativeGroup.push(subList);
        }
      }

      //通过分组数据创建创意组
      this.dataList = this.dataList.filter((item) => item.creatives.length > 0); //去除已有的空数据

      creativeGroup.forEach((cerativesList) => {
        if (this.dataList.length < 30) {
          this.dataList.push({
            itemId: Math.random(),
            group_name: "新建创意组" + (this.dataList.length + 1),
            creatives: cerativesList,
          });
        }
      });
      this.saveInstore();
    },
    fillAndSaveCurData(dataList) {
      if (this.formData.curMaterialType === "video") {
        for (let dataItem of Object.values(dataList)) {
          if (!this.videoList.map((item) => item.uuid).includes(dataItem.uuid)) {
            if (this.videoList.length < 10) {
              this.videoList.push({
                uuid: dataItem.uuid,
                path: dataItem.path,
                coverPath: dataItem.coverPath,
              });
            } else {
              this.$message({
                message: "视频数量超出限制",
                type: "warning",
              });
              break;
            }
          }
        }
      } else {
        for (let dataItem of Object.values(dataList)) {
          if (!this.imageList.map((item) => item.uuid).includes(dataItem.uuid)) {
            if (this.imageList.length < 12) {
              this.imageList.push({
                uuid: dataItem.uuid,
                path: dataItem.path,
              });
            } else {
              this.$message({
                message: "图片数量超出限制",
                type: "warning",
              });
              break;
            }
          }
        }
      }
      this.confirmSelect(); //选择完成后就进行保存
    },
    deleteItem(uuid) {
      if (this.formData.curMaterialType === "video") {
        let delIndex = this.videoList.findIndex((item) => item.uuid === uuid);
        this.videoList.splice(delIndex, 1);
      } else {
        let delIndex = this.imageList.findIndex((item) => item.uuid === uuid);
        this.imageList.splice(delIndex, 1);
      }
      this.confirmSelect(); //删除完成后进行保存
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    //分组时不是格式化的当前list, 而是格式化外部传来的数据
    formatData(groupList) {
      return new Promise((resolve) => {
        let contentArr = groupList || this.videoList.concat(this.imageList);
        if (contentArr.length > 0) {
          this.loading = true;
          getToutiaoId({
            advertiserId: this.adCount,
            fileNames: contentArr.map((item) => item.uuid).join(),
          }).then((res) => {
            this.loading = false;
            if (res.code === "0000") {
              let toutiaoArr = res.data;
              let videoArr = [];
              let imageArr = [];
              toutiaoArr.forEach((item) => {
                if (item.toutiaoId) {
                  if (/^video/g.test(item.format)) {
                    videoArr.push({
                      video_id: item.toutiaoId,
                      image_id: item.toutiaoCoverId, //视频封面
                      type: "video",
                      image_mode: item.fileMode || null,
                      creative_name: item.name,
                      //回显需要
                      uuid: item.uuid,
                      image_url: item.coverPath,
                      video_url: item.path,
                    });
                  } else {
                    imageArr.push({
                      image_id: item.toutiaoId,
                      type: "img",
                      image_mode: item.fileMode || null,
                      image_name: item.name,
                      //回显需要
                      uuid: item.uuid,
                      image_url: item.path,
                    });
                  }
                } else {
                  this.$message.error("部分素材获取头条ID失败");
                }
              });

              let saveData = {
                group_name: this.formData.creativeGroupName,
                creatives: videoArr.concat(imageArr),
              };
              // if (imageArr.length > 0) {
              //   saveData.creatives.push({
              //     image_ids: imageArr.map((imgItem) => imgItem.image_id),
              //     image_urls: imageArr.map((imgItem) => imgItem.image_url),
              //     image_uuids: imageArr.map((imgItem) => imgItem.uuid),
              //   });
              // }
              resolve(saveData);
            }
          });
        } else {
          resolve({
            group_name: this.formData.creativeGroupName,
            creatives: [],
          });
        }
      });
    },
    //编辑数据弹框
    showEditModal(dataItem) {
      this.curItem = dataItem; //接口数据格式
      this.videoList = [];
      this.imageList = [];
      this.formData.creativeGroupName = dataItem.group_name;
      if (dataItem.creatives.length > 0) {
        dataItem.creatives.forEach((creative) => {
          if (creative.video_id) {
            //视频素材
            this.videoList.push({
              uuid: creative.uuid,
              path: creative.video_url,
              coverPath: creative.image_url,
            });
          } else {
            //图片素材
            this.imageList.push({
              uuid: creative.uuid,
              path: creative.image_url,
            });
            // for (let i = 0; i < creative.image_ids.length; i++) {
            //   this.imageList.push({
            //     uuid: creative.image_uuids[i],
            //     path: creative.image_urls[i],
            //   });
            // }
          }
        });
      }
    },
    confirmSelect: async function () {
      // if (this.formData.creativeGroupName === "") {
      //   this.$message({
      //     message: "请填写创意组名称",
      //     type: "warning",
      //   });
      //   return;
      // }
      let saveData = await this.formatData();
      this.curItem.group_name = saveData.group_name;
      this.curItem.creatives = saveData.creatives;
      this.saveInstore();
      this.$nextTick(() => {
        this.$refs.modelRef.validate(() => {});
      });
    },
    saveCreativeGroup: async function () {
      if (this.formData.creativeGroupName === "") {
        this.$message({
          message: "请填写创意组名称",
          type: "warning",
        });
        return;
      }
      let saveData = await this.formatData();
      this.loading = true;
      saveCreativeGroup({
        creative_item: JSON.stringify(saveData),
        advertiserId: this.adCount,
      }).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.$message({
            message: "创意组保存成功",
            type: "success",
          });
          this.curItem.group_name = saveData.group_name;
          this.curItem.creatives = saveData.creatives;
          this.saveInstore();
        }
      });
    },
    saveInstore() {
      let copyData = JSON.parse(JSON.stringify(this.dataList));

      let storeData = copyData.map((item) => {
        return {
          itemId: item.itemId,
          group_name: item.group_name,
          creatives: item.creatives,
        };
      });
      this.$store.commit("set_creative_groups_ttV2", storeData);
    },
    //选择已有创意组
    selectGroup() {
      this.$refs.checkedModalRef.showModal();
      //查询创意组
      queryCreativeGroup().then((res) => {
        if (res.code === "0000") {
          this.tableData = res.creativeGroups;
        }
      });
    },
    selectOk(dataList) {
      dataList.forEach((item) => {
        let groupItem = JSON.parse(item.creative_item);
        this.dataList.push({
          itemId: Math.random(),
          group_name: groupItem.group_name,
          creatives: groupItem.creatives,
        });
      });
      this.saveInstore();
    },
    //检查并且保存最终数据（创意组数据已经实时同步到store，无需再次保存,只用检查必填项）
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          this.showNoDataTip = false;
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];
            if (item.group_name === "" || item.creatives.length === 0) {
              pass = false;
              this.showEditModal(item);
              this.$nextTick(() => {
                this.$refs.modelRef.validate(() => {});
              });
              break;
            }
          }
          if (pass) {
            resolve();
          } else {
            reject();
          }
        } else {
          this.showNoDataTip = true;
          reject();
        }
      });
    },
    //修改创意组实时更新到store
    changeGroupName(name) {
      this.$store.commit("set_creative_groupName_ttV2", {
        id: this.curItem.itemId,
        name: name,
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      creative_groups: (state) => state.PromotionTtV2.creative_groups,
      deliveryRange: (state) => state.PromotionTtV2.deliveryRange,
    }),
  },
  watch: {
    creative_groups(value) {
      if (value) {
        this.dataList = value.map((item) => {
          return {
            itemId: item.itemId,
            group_name: item.group_name,
            creatives: item.creatives,
          };
        });
        if (this.dataList.length > 0) {
          let curId = this.curItem.itemId;
          let curItem = this.dataList.find((item) => item.itemId === curId);
          if (curItem) {
            this.showEditModal(curItem);
          } else {
            this.showEditModal(this.dataList[this.dataList.length - 1]);
          }
        }
      }
    },
    deliveryRange(value) {
      if (value.delivery_range === "UNION" && value.union_video_type === "SPLASH_VIDEO") {
        this.isUnionSplash = true;
        this.formData.curMaterialType = "image";
      } else {
        this.isUnionSplash = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.creative-group-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
    .nodata-tip {
      color: #f56c6c;
      font-size: 12px;
      position: relative;
      left: 10px;
      top: 1px;
    }
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
  .modal-body {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 85px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          .upload-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            /deep/ .el-form-item__content {
              line-height: 25px;
            }
            .add-btn {
              padding: 0px;
              margin: 0px;
            }
          }
          .upload-wrap {
            margin-top: 10px;
            border-radius: 2px;
            background: rgba(244, 244, 244, 1);
            padding: 8px 0px 16px 16px;
            .content-wrap {
              height: 300px;
              overflow: auto;
              display: flex;
              flex-wrap: wrap;
              &::-webkit-scrollbar {
                display: none;
                width: 0 !important;
                height: 0 !important;
                background: transparent;
              }
              &.video-wrap {
                .video-item {
                  padding: 9px 0px 9px 9px;
                  height: 176px;
                  border-radius: 4px;
                  border: 1px solid rgba(0, 0, 0, 0.11);
                  box-sizing: border-box;
                  background: rgba(255, 255, 255, 1);
                  display: flex;
                  position: relative;
                  margin: 8px 12px 0px 0px;

                  .video-slide {
                    width: 108px;
                    margin-right: 9px;
                    .video-header {
                      color: rgba(0, 0, 0, 0.65);
                      font-size: 14px;
                      padding: 4px 0;
                    }
                    .video-content {
                      display: inline-block;
                      width: 108px;
                      height: 130px;
                      background-color: #eee;
                      .material {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                      }
                    }
                  }
                  .close-btn {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: rgba(214, 214, 214, 1);
                    text-align: center;
                    line-height: 14px;
                    cursor: pointer;
                    font-size: 12px;
                  }
                }
              }
              &.image-wrap {
                .img-item {
                  height: 176px;
                  width: 240px;
                  padding: 9px;
                  border-radius: 4px;
                  border: 1px solid rgba(0, 0, 0, 0.11);
                  box-sizing: border-box;
                  background: rgba(255, 255, 255, 1);
                  position: relative;
                  margin: 8px 16px 8px 0px;
                  .img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .close-btn {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: rgba(214, 214, 214, 1);
                    text-align: center;
                    line-height: 14px;
                    cursor: pointer;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
    }
  }
  .select-count {
    height: 300px;
    font-size: 20px;
    color: #818181;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
